exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component-vcchelp-circle-button:hover .darkener{background-color:rgba(0,0,0,.1)}", ""]);

// exports
